<template>
    <div class="SalesEnquiryContactInfo">
        <div class="SalesEnquiryContactInfo_Nav" v-for="(item,index) in temp_Value" :key="index">
            <div class="row">
                <div class="col-12 mb-2 Input_Label">
                    <div class="Input_Label_Left">
                         {{$t("lbl_EMPBE_CompanyInfo_Contact_Dialog_Title")}} {{(index+1)}} <!--<span class="text-danger">*</span> --> <span v-if="index==0">
                            {{$t("lbl_EMPBE_CompanyInfo_Contact_Dialog_TitleRight")}}
                        </span>
                    </div>
                    <div class="Input_Label_Right" v-if="index > 0"><a href="javascript:;" @click="Del(index)"><img
                                :src="cdnURL+'DelSale_Enquiry.svg'" /></a></div>
                </div>

                <div class="MoreDivInLine_8 col-12">
                    <div class="MoreDivInLine_Row">
                        <textbox 
                            v-model="item.contactPersonT" 
                            :ControlId="'contactPersonT_'+index" 
                            :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_PersonName_PlaceOther')"
                            type="text">
                        </textbox>
                    </div>
                    <div class="MoreDivInLine_Row">
                        <textbox 
                            v-model="item.contactPersonPosition" 
                            :ControlId="'contactPersonPosition_'+index" 
                            :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Position_PlaceOther')"
                            type="text">
                        </textbox>
                    </div>
                </div>
            </div>
            <!---手机--->
            <div class="row">
                <div class="col-12 mb-2 Input_Label">
                    <div class="Input_Label_Left">
                        {{$t("lbl_EMPBE_CompanyInfo_Contact_Dialog_MobileNumber")}}
                    </div>
                </div>
                <div class="MoreDivInLine_8 col-12">
                    <div class="MoreDivInLine_Row">
                        <selection 
                            :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_CountryRegionCode_PlaceOther')" 
                            label="Name"
                            v-model="item.contactPhoneCountryCode" 
                            :options="Temp_CellCountryOptions" 
                            :ControlId="'contactPhoneCountryCode_'+index" 
                            :multiple="false"
                            @fromChird_TreeSelected="PhoneSelected($event,item)">
                        </selection>
                    </div>
                    <div class="MoreDivInLine_Row">
                        <textbox 
                            :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_MobileNumber')" 
                            type="number"
                            v-model="item.contactPhoneNumber" 
                            :ControlId="'contactPhoneNumber_'+index" 
                            :class="{ 'is-invalid': item.contactPhoneNumber }"
                            @input="phoneInput($event,item)">
                        </textbox>
                    </div>
                    <div class=" verifyButton ">
                        <!--发送验证码-->
                        <button class="btn btn-primary" v-show="!item.isContactPhoneValidate"
                            :disabled="item.smsdisabled || item.contactPhoneNumber?.length <= 0" type="button"
                            @click="getValidSMSCodeAfter(index)">
                            <span>{{ item.smstext }}</span>
                        </button>
                        <!---已验证--->
                        <button v-show="item.isContactPhoneValidate" class="btn btn-success" disabled="true"
                            type="button">
                            <span>{{ $t("lbl_EMPBE_HadValid") }}</span>
                        </button>
                        <GeetestCaptcha  :ResloveItem="item" @captchaVerifyCallbackGeetest="SMSfinishSlideGeetest"
                            ref="SMScaptchaInstance" :currentUrlName="GetIsUatName" />
                    </div>
                </div>

                <!-- <div class="col-5" v-if="user.userType == 'ADMIN' && !item.isContactPhoneValidate">
                    <button class="btn btn-primary" :disabled="item.smsdisabled || item.phoneNumLength <= 0" type="button"
                            @click="AdminCheckPhoneCode(item)">
                            <span>{{ $t('lbl_EMPBE_VerifyManually') }}</span>
                    </button>
                </div> -->
                <div class="col-12">
                    <textbox 
                        :ControlId="'smsCode_'+index" 
                        v-show="!item.isContactPhoneValidate && item.smsBtnStatus" 
                        :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_VerificationCode_PlaceOther')"
                        type="number" 
                        v-model="item.smsCode" 
                        @blur="CheckPhoneCode($event,item)">
                    </textbox>
                </div>
            </div>
            <!---邮箱--->
            <div class="row">
                <div class="col-12 mb-2 Input_Label">
                    <div class="Input_Label_Left">
                        {{ $t("lbl_EMPBE_CompanyInfo_Contact_Dialog_Email") }}
                    </div>
                </div>

                <div class="MoreDivInLine_8 col-12">
                    <div class="MoreDivInLine_Row">
                        <div>
                            <textbox   style="margin-bottom: 0px !important;"
                                :title="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Email_PlaceOther')" 
                                type="email" id="contactEmail"
                                v-model="item.contactEmail" 
                                :ControlId="'contactEmail_'+index" 
                                @input="emailInput($event,item)">
                            </textbox>
                        </div>
                        <div class="emailTips">
                            {{ $t("lbl_EMPBE_CompanyInfo_Contact_Dialog_FooterTips_First") }}
                        </div>
                    </div>
                    <div class=" verifyButton ">
                        <!--发送验证码-->
                        <button class="btn btn-primary" v-show="!item.isContactEmailValidate"
                            :disabled="item.emaildisabled || (item.contactEmail && item.contactEmail.length <= 0)" type="button"
                            @click="getValidEmailCodeAfter(index)">
                            <span>{{ item.emailtext }}</span>
                        </button>
                        <!---已验证--->
                        <button v-show="item.isContactEmailValidate" class="btn btn-success" disabled="true"
                            type="button">
                            <span>{{ $t("lbl_EMPBE_HadValid") }}</span>
                        </button>
                        <GeetestCaptcha :ResloveItem="item" @captchaVerifyCallbackGeetest="EmailfinishSlideGeetest"
                            ref="EmailcaptchaInstance" :currentUrlName="GetIsUatName" />
                    </div>
                </div>
                <!-- <div class="col-5" v-if="user.userType == 'ADMIN' && !item.isContactEmailValidate">
                    <button class="btn btn-primary" :disabled="item.emaildisabled || item.emailLength <= 0" type="button"
                        @click="AdminCheckEmailCode">
                        <span>{{ $t('lbl_EMPBE_VerifyManually') }}</span>
                    </button>
                </div> -->
                <div class="col-12">
                    <textbox 
                        v-show="!item.isContactEmailValidate && item.emailBtnStatus" 
                        :placeholder="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_VerificationCode_PlaceOther')"
                        type="number" 
                        v-model="item.emailCode" 
                        :ControlId="'emailCode_'+index" 
                        @blur="CheckEmailCode($event,item)">
                    </textbox>

                </div>
                <div class="col-12 SeconedEmailTips" v-html="$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_FooterTips_Seconed')">
                </div>
            </div>
           <!-- <div class="row">
                <div class="col-12 mb-2 Input_Label">
                    <div class="Input_Label_Left">
                        Remarks
                    </div>
                </div>
                 <div class="col-12">
                    <textbox
                        ControlId="remarks" 
                        :title="'Any remarks for this contact'" 
                        id="remarks"
                        v-model="item.remarks">
                    </textbox>
                </div> 
            </div>-->

        </div>
        <div class="addMore">
            <b-button v-if="temp_Value.length < nums" class="btn btn-outline-primary p-l-15 d-flex align-items-center"
                variant="outline-primary" @click="Add" v-bind:t_label="'EMPBE_CompanyCenter_Sale_Enquiry_Add'">
                <feather type="plus-circle"> </feather>
                &nbsp;{{ $t("lbl_EMPBE_CompanyInfo_Contact_AddButtom") }}
            </b-button>

        </div>
    </div>
</template>
<script>

import { CompanyInfoService } from "@/_services/CompanyInfo.Service";
import GeetestCaptcha from '../../../components/GeetestCaptcha.vue';
export default {
    components: {GeetestCaptcha},
    props: ['value','nums','CellCountryOptions'],
    data(){
        return{
            InitForm:
            {
                contactPersonT:"",
                contactPersonPosition:"",
                contactPhoneCountry:undefined,
                contactPhoneCountryCode:undefined,
                contactPhoneNumber:"",
                isContactPhoneValidate:false,
                contactEmail:"",
                isContactEmailValidate:false,
                remarks:"",
                smsBtnStatus:false,
                emailBtnStatus:false,
                smstext: this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Verify'),
                emailtext: this.$t('lbl_EMPBE_CompanyInfo_Contact_Dialog_Verify'),
                smsCode:"",
                emailCode:"",
                isValidEmail:false,
                smsdisabled:false,
                emaildisabled:false,
                smsguid:"",
                emailguid:"",
            },
            temp_Value:this.value,
            Temp_CellCountryOptions:this.CellCountryOptions,
            cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
        }
    },
    watch:{
        value()
        {
            this.temp_Value = this.value;
        },
        temp_Value:{
            handler() 
            {
                this.$emit("input",this.temp_Value);
            },deep:true

        }
    },
    computed: {
        user() {
            return this.$store.state.authentication.user;
        },
        GetIsUatName(){
            var isUatName = process.env.VUE_APP_EMP_ENV_NAME=="UAT"?"eMarketplaceUat_Back":"eMarketplace_Back";
            isUatName =  process.env.VUE_APP_EMP_ENV_NAME=="AI"?"eMarketplaceAi_Back":isUatName;

            return isUatName;
        },
      
    },
    methods:
     {  
        generateGuid() {  
            // 使用 JavaScript 生成 GUID 的函数  
            function s4() {  
                return Math.floor((1 + Math.random()) * 0x10000)  
                .toString(16)  
                .substring(1);  
            }  
  
            return `${s4()}${s4()}-${s4()}-${4 | s4()}-${5 | s4()}-${s4()}${s4()}${s4()}`;  
        } , 
        Del(index)
        {
            this.temp_Value.splice(index,1);
        },
        Add(){
            
            var Contact = Object.assign({}, this.InitForm);
            this.temp_Value.push(Contact);
        },
        getValidSMSCodeAfter(index)
        {
            this.$refs.SMScaptchaInstance[index].showGeetest();
        },
        getValidEmailCodeAfter(index){

            this.$refs.EmailcaptchaInstance[index].showGeetest();
        },
        PhoneSelected(obj,item){
            item.contactPhoneCountryCode=obj.id;
            item.contactPhoneCountry = obj.label.match(/\d+/)[0];

        },
        SMSfinishSlideGeetest(captchaVerifyParam,resolve,item){
            this.$nextTick(() => {
            this.getValidSMSCode(captchaVerifyParam,item).then(result => {
                // 使用resolve函数将业务结果传递回子组件
                resolve(result);
            });
            });
        },
        EmailfinishSlideGeetest(captchaVerifyParam,resolve,item){
            this.$nextTick(() => {
            this.getValidEmailCode(captchaVerifyParam,item).then(result => {
                // 使用resolve函数将业务结果传递回子组件
                resolve(result);
            });
            });
        },
        phoneInput(inputVal,item)
        {
            if (inputVal != "" && item.smsguid != "") {
                item.smsguid = "";
            }
            item.isContactPhoneValidate = false;
        },
        emailInput(inputVal,item) {
            if (inputVal != "" && item.emailguid != "") {
                item.emailguid = "";
            }
            item.isContactEmailValidate = false;
        },
        //验证验证码
        CheckPhoneCode(inputVal,item) {
            var params_checkCode = {
                guid: item.smsguid,
                code: inputVal,
            };
            if (item.smsguid !== "" && inputVal !== "") {
                CompanyInfoService.checkValidCode(params_checkCode).then((res) => {
                if (res.data == "True") {
                    //更改状态
                    item.isContactPhoneValidate = true;
                } else {

                    this.$swal({
                    text: this.$t("Lbl_EMPBE_VerificationFail"),
                    showCancelButton: false,
                    confirmButtonText: this.$t("lbl_EMPBE_Confirm")
                    });
                    item.isContactPhoneValidate = false;
                }
                });
            }
        },
        
        //邮箱验证码验证
        CheckEmailCode(inputVal,item) {
            var params_checkCode = {
                guid: item.emailguid,
                code: inputVal,
            };
            if (item.emailguid !== "" && inputVal !== "") {
                CompanyInfoService.checkValidCode(params_checkCode).then((res) => {
                if (res.data == "True") {
                    //更改状态
                 
                    item.isContactEmailValidate = true;
                } else {
                    this.$swal({
                    text: this.$t("Lbl_EMPBE_VerificationFail"),
                    showCancelButton: false,
                    confirmButtonText: this.$t("lbl_EMPBE_Confirm")
                    });
                    item.isContactEmailValidate = false;
                }
                });
            }
        },
        AdminCheckPhoneCode() {
            this.$swal({
                //Show Alert
                text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
                showCancelButton: true,
                type: "confirm",
                showConfirmButton: true,
                confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
                cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
            }).then(async (res) => {
                if (res.isConfirmed) {
                    var updateType = "phone";
       
                    item.isContactPhoneValidate = true;
                }
            })
        },
        AdminCheckEmailCode() {
            this.$swal({
                //Show Alert
                text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
                showCancelButton: true,
                type: "confirm",
                showConfirmButton: true,
                confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
                cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
            }).then(async (res) => {
                if (res.isConfirmed) {
                    var updateType = "email";
      
                    item.isContactEmailValidate = true;
                }
            })
        },
        //发短信
        getValidSMSCode(data,item) {
        item.smstext = this.$t("lbl_EMPBE_GettingValidationCode");
        var area = item.contactPhoneCountry;
        var phoneNumber = item.contactPhoneNumber;
        return new Promise((resolve, reject) => {
            if (area != "" && phoneNumber != "") {
            var Parms =
            {
                typename:"CPS_Login",
                captcha_output:data.captcha_output,
                gen_time:data.gen_time,
                lot_number:data.lot_number,
                pass_token:data.pass_token,
                area:area,
                phoneNumber:phoneNumber,
                IsUat:process.env.VUE_APP_EMP_IsUat,
                guid:this.generateGuid()
            }
            CompanyInfoService.GetPhoneValidCode(Parms)
                .then((res) => {
                    console.log("res",res)
                if(res.data==1001)
                {
                    this.$swal({
                        text: this.$t("lbl_EMPBE_Geetest_Verification"),
                        showCancelButton: false,
                        confirmButtonText: this.$t("lbl_EMPBE_Confirm")
                    });
                    item.smstext = this.$t("Lbl_EMPBE_GetVerificationCode");
                    return;
                }
                if ((res.status = 200)) {
                    let that = this;
                    item.smsguid = res.data;
                    var timer = 1;
                    if (timer == 1) {
                    timer = 0;
                    var time = 60;
                    let that2 = that;
                    var SMSSendleftText = this.$t("lbl_EMPBE_SMSSendleft");
                    var msmtest = this.$t("Lbl_EMPBE_GetVerificationCode");
                    var inter = setInterval(function () {
                        //倒计时
                        if (SMSSendleftText != "") {
                            item.smstext = SMSSendleftText.replace(/#second#/, time);
                        }
                        item.smsdisabled = true;
                        time--;
                        if (time < 0) {
                        timer = 1;
                        clearInterval(inter);
                        item.smstext = msmtest;
                        item.smsdisabled = false;
                        }
                    }, 1000);
                    item.smsBtnStatus=true;
                    }
                } 
                else {
                    this.$Alert(0,"error");
                console.log("error");
                }
                resolve(res);
                })
                .catch((err) => {
                    this.$Alert(0,"error");
                console.log("error:" + err);
                });
            }
        });
    
        },
        //发邮箱
        getValidEmailCode(data,item) {
        item.emailtext = this.$t("lbl_EMPBE_GettingValidationCode");
        this.validateEmail(item);
        return new Promise((resolve, reject) => {
            if (item.isValidEmail) {
            var Parms =
            {
                typename:"CPS_Login",
                captcha_output:data.captcha_output,
                gen_time:data.gen_time,
                lot_number:data.lot_number,
                pass_token:data.pass_token,
                email:item.contactEmail,
                IsUat:process.env.VUE_APP_EMP_IsUat,
                guid:this.generateGuid()
            }
            CompanyInfoService.GetEmailValidCode(Parms)
            .then((res) => {
                if(res.data==1001)
                {
                    this.$swal({
                        text: this.$t("lbl_EMPBE_Geetest_Verification"),
                        showCancelButton: false,
                        confirmButtonText: this.$t("lbl_EMPBE_Confirm")
                    });
                    item.emailtext = this.$t("Lbl_EMPBE_GetVerificationCode");
                    return;
                }
                if (res.status === 200) {
                item.emailguid = res.data;
                var timer = 1;
                if (timer == 1) {
                    timer = 0;
                    var time = 60;
                    var emailSendleftText = this.$t("lbl_EMPBE_SMSSendleft");
                    var text = this.$t("Lbl_EMPBE_GetVerificationCode");
                    var inter = setInterval(function () {
                    //倒计时
                    if (emailSendleftText != "") {
                        item.emailtext = emailSendleftText.replace(/#second#/, time);
                    }
                    item.emaildisabled = true;
                    time--;
                    if (time < 0) {
                        timer = 1;
                        clearInterval(inter);
                        item.emailtext = text;
                        item.emaildisabled = false;
                        //that2.form.companyContact.isContactEmailValidate=false;
                    }
                    }, 1000);
                    item.emailBtnStatus=true;
                }
                }
                else {
                    this.$Alert(0,"error");
                console.log("error");
                }
                resolve(res);
            })
            .catch((err) => {
                this.$Alert(0,"error");
                console.log("error:" + err);
            });
        }
        });
        
        },
        //验证邮箱
        validateEmail(item) {
            // 邮箱正则表达式
            const emailRegex = /^[a-zA-Z0-9]+([._\\\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/;
            var isEmail = emailRegex.test(item.contactEmail);
            item.isValidEmail = isEmail;
            return isEmail;
        },
    
    }

}
</script>
<style lang="scss" scoped>
    .SalesEnquiryContactInfo_Nav
    {
        padding: 16px;
        border-radius: 16px;
        border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
        margin-top: 16px;
        .verifyButton
        {
        }
        .emailTips{
            margin-bottom:  25px !important;   
             padding: 0px 20px 0 20px;
            color: var(--Light-Text-Secondary, rgba(0, 0, 0, 0.60));
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 166.667% */
            letter-spacing: 0.4px;
        }
        .SeconedEmailTips
        {
            margin-bottom:  25px !important;   
             padding: 0px 20px 0 20px;
            color: var(--Light-Text-Secondary, rgba(0, 0, 0, 0.60));
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px; /* 166.667% */
            letter-spacing: 0.4px;
        }
     
    }
    .addMore
    {
            margin-top: 16px;

    }
</style>